import React from 'react';

import { Box, Card, Flex, FlexProps, Paper, Text, Title } from '@mantine/core';
import bgImage from 'assets/images/bg.png';
import { Branding } from 'components/Branding';
import { LanguageChange } from 'components/LanguageChange';

interface FullScreenAlertProps extends FlexProps {
  header?: string | React.ReactNode;
  body?: string | React.ReactNode;
  notice?: string;
  showLanguageChange?: boolean;
  cta?: React.ReactNode;
  cardMinWidth?: number;
}

export function FullScreenAlert({
  header,
  body,
  notice,
  showLanguageChange,
  cta,
  cardMinWidth,
  ...flexProps
}: FullScreenAlertProps) {
  return (
    <Flex
      h="100svh"
      w="100vw"
      {...flexProps}
      direction="column"
      align="center"
      justify="center"
      pos="relative"
      sx={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',

        backgroundPosition: 'center'
      }}>
      <Card withBorder p="xl" miw={cardMinWidth}>
        <Flex align="center" justify="center" direction="column">
          <Branding width={125} />
          {header &&
            (typeof header === 'string' ? (
              <Title mt="md" order={4}>
                {header}
              </Title>
            ) : (
              <Flex align="center" direction="column" justify="center">
                {header}
              </Flex>
            ))}
          {body &&
            (typeof body === 'string' ? (
              <Text mt="md" maw={350} align="center">
                {body}
              </Text>
            ) : (
              <Flex align="center" direction="column" justify="center">
                {body}
              </Flex>
            ))}
          {notice && (
            <Paper withBorder p="md" mt="sm" sx={(theme) => ({ backgroundColor: theme.other.gray.bg })}>
              <Text align="center" maw={350}>
                {notice}
              </Text>
            </Paper>
          )}
          {cta && (
            <Flex align="center" justify="center" w="100%" mt="md">
              {cta}
            </Flex>
          )}
        </Flex>
      </Card>
      {showLanguageChange && (
        <Box pos="absolute" style={{ right: 20, bottom: 20 }}>
          <LanguageChange />
        </Box>
      )}
    </Flex>
  );
}
